var _defs, _path, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _g, _path2, _path3, _ellipse, _path4, _path5, _path6, _path7, _path8, _path9, _g2, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21, _circle22, _circle23, _circle24, _circle25, _circle26, _circle27, _circle28, _circle29, _circle30, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _circle31, _path71, _g3, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _rect, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgConnectopiaLandingPage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "data-name": "Layer 1",
    width: 1142.23,
    height: 781.11,
    viewBox: "0 0 1142.23 781.11",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "d91c7811-87ec-4fc8-aa52-46c2543d8327-428",
    x1: 380.12,
    y1: 690.08,
    x2: 530.06,
    y2: 690.08,
    gradientTransform: "matrix(-1, 0, 0, 1, 967, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "friendship") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1169.87,387.2c-6.95,28.15-42.63,42.26-62.62,63.26-37.67,39.58-23,97.38.9,143.67,8,15.5,17.08,31.91,13.69,48.53-4.13,20.33-26.08,35.19-49.13,43.07-42,14.35-92.3,10.93-130.91-8.92-33.36-17.15-57.26-45-91.19-61.42-56.79-27.39-129.07-17-190.74,1.83C616.25,630.57,568.55,647.94,525.2,634c-30.5-9.82-51.59-33.72-63.08-59-5.54-12.23-9.57-25.47-20.16-35.16-6.3-5.77-14.52-9.86-22.93-13.3-76.88-31.5-174-14.63-248.63-49.57-50.42-23.59-82.71-68.09-97-114.5s-12.63-95.07-9-142.87c2.58-34,7.21-70.22,33.47-96.44,27.78-27.73,75.45-38,118.55-32.77s82.15,24.06,116.52,46.18c43,27.66,82.78,62.09,135.51,73.29,35.91,7.63,73.68,3.45,110.72,2,61.92-2.41,123.86,3,185.43,8.84,30,2.87,60.1,5.88,89.84,10.24q10,1.46,20,3.15c3.34.57,6.68,1.16,10,1.77,2.6.47,5.19,1,7.78,1.47q6.13,1.19,12.22,2.5c11.66,2.5,23.21,5.33,34.64,8.55,39.74,11.21,71.6,31.57,109.13,45.79,24.46,9.27,51.13,11.83,74.29,23.63C1151,332.29,1177.18,357.6,1169.87,387.2Z",
    transform: "translate(-28.88 -59.45)",
    fill: "#ff3b30",
    opacity: 0.1
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 939.95,
    cy: 375.52,
    r: 102.23,
    fill: "#ff3b30"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 831.23,
    cy: 347.59,
    r: 102.23,
    fill: "#ff3b30"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 711.55,
    cy: 348.59,
    r: 102.23,
    fill: "#ff3b30"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 672.65,
    cy: 375.52,
    r: 102.23,
    fill: "#ff3b30"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 606.82,
    cy: 384.5,
    r: 102.23,
    fill: "#ff3b30"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 579.89,
    cy: 303.71,
    r: 102.23,
    fill: "#ff3b30"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 609.81,
    cy: 209.95,
    r: 102.23,
    fill: "#ff3b30"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 666.66,
    cy: 209.95,
    r: 102.23,
    fill: "#ff3b30"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 699.58,
    cy: 168.06,
    r: 102.23,
    fill: "#ff3b30"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 783.36,
    cy: 213.94,
    r: 102.23,
    fill: "#ff3b30"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 978.85,
    cy: 303.71,
    r: 102.23,
    fill: "#ff3b30"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 920,
    cy: 252.84,
    r: 102.23,
    fill: "#ff3b30"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 882.1,
    cy: 201.97,
    r: 102.23,
    fill: "#ff3b30"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 810.29,
    cy: 125.17,
    r: 102.23,
    fill: "#ff3b30"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 943.94,
    cy: 209.95,
    r: 102.23,
    fill: "#ff3b30"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 939.95,
    cy: 375.52,
    r: 102.23
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 831.23,
    cy: 347.59,
    r: 102.23
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 711.55,
    cy: 348.59,
    r: 102.23
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 672.65,
    cy: 375.52,
    r: 102.23
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 606.82,
    cy: 384.5,
    r: 102.23
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 579.89,
    cy: 303.71,
    r: 102.23
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 609.81,
    cy: 209.95,
    r: 102.23
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 666.66,
    cy: 209.95,
    r: 102.23
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 699.58,
    cy: 168.06,
    r: 102.23
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 783.36,
    cy: 213.94,
    r: 102.23
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 978.85,
    cy: 303.71,
    r: 102.23
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 920,
    cy: 252.84,
    r: 102.23
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 882.1,
    cy: 201.97,
    r: 102.23
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 810.29,
    cy: 125.17,
    r: 102.23
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 943.94,
    cy: 209.95,
    r: 102.23
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M918.34,614.12s62.5-52.53,31.58-127.33L919,475.21,885.45,578.5Z",
    transform: "translate(-28.88 -59.45)",
    fill: "#67647e"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M921.67,471.65l7.4,2.77L896.13,575.83l28.74,31.12c-2.38,2.37-3.86,3.61-3.86,3.61l-32.9-35.62Z",
    transform: "translate(-28.88 -59.45)",
    opacity: 0.1
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 579.5,
    cy: 687.94,
    rx: 556.5,
    ry: 93.16,
    fill: "#ff3b30",
    opacity: 0.1
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1036.72,603.1s-20.33,20.33-8.85,50.5-19.67,80.33-19.67,80.33l1-.16c41.75-7.37,62.5-55.12,39.28-90.6C1039.8,630,1032.71,614.52,1036.72,603.1Z",
    transform: "translate(-28.88 -59.45)",
    fill: "#ff3b30"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1036.72,603.1s-11.48,24.92,0,45.25,2,77.38-28.53,85.58",
    transform: "translate(-28.88 -59.45)",
    fill: "none",
    stroke: "#535461",
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1072.93,685.33s-23.2-3.69-25.31,17.1S1003,726.1,1003,726.1l.8.53c35.09,23,68.63,14.67,63.57-15.91C1065.5,699.35,1065.65,687.93,1072.93,685.33Z",
    transform: "translate(-28.88 -59.45)",
    fill: "#ff3b30"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1072.93,685.33s-23.2-3.69-25.31,17.1S1003,726.1,1003,726.1l.8.53c35.09,23,68.63,14.67,63.57-15.91C1065.5,699.35,1065.65,687.93,1072.93,685.33Z",
    transform: "translate(-28.88 -59.45)",
    fill: "#f5f5f5",
    opacity: 0.2
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M1072.93,685.33s-18,4-16.53,20.33-26.74,36-53.39,20.44",
    transform: "translate(-28.88 -59.45)",
    fill: "none",
    stroke: "#535461",
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M636.08,504.71l8.12,32.5s57.37,7.48,95.62,2.78a49.72,49.72,0,0,0,19.07-6.88c3.23-1.91,8.33-2.74,15.3,2.48,11.94,9,70.54,81,61.05,155.7a25.82,25.82,0,0,1-22.17,22.24h0a77.86,77.86,0,0,0-32.67,12.36l-29,19.31,297.35-6.5-30.87-37.37s-21.12-17.87-37.37-19.5c-4.74-.47-8.65-4.82-11.81-10.73-18.51-34.65-40.65-67.23-64.65-98.34-17.48-22.66-32.15-46.54-30.78-61.54,3.25-35.75,0-94.24,0-94.24l-61.74-8.12s8.12,78-66.62,97.49S636.08,504.71,636.08,504.71Z",
    transform: "translate(-28.88 -59.45)",
    fill: "#67647e"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M686.45,519.34s34.12,21.12,108.87,1.62,66.62-97.49,66.62-97.49L873.69,425c-.22-5-.39-8-.39-8l-61.74-8.12s8.12,78-66.62,97.49-108.87-1.62-108.87-1.62l8.12,32.5s21.92,2.86,47.7,3.93Z",
    transform: "translate(-28.88 -59.45)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M830.77,740.51a77.86,77.86,0,0,1,32.67-12.36h0A25.78,25.78,0,0,0,885.6,706c9.54-74.7-49.09-146.83-61-155.79-13-9.75-19.5,1.62-19.5,1.62a104.61,104.61,0,0,1-14,2.67c21.06,28,51.19,81.71,44.14,136.87a25.78,25.78,0,0,1-22.16,22.15h0a77.86,77.86,0,0,0-32.67,12.36l-29,19.31,74.76-1.63Z",
    transform: "translate(-28.88 -59.45)"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M685.84,662.36s-6.21-21.08,1.16-36.6a33.3,33.3,0,0,0,2.69-20.89,56,56,0,0,0-3-9.81",
    transform: "translate(-28.88 -59.45)",
    fill: "none",
    stroke: "#535461",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M691.33,585.25c0,2.58-4.68,10.08-4.68,10.08S682,587.83,682,585.25a4.68,4.68,0,1,1,9.36,0Z",
    transform: "translate(-28.88 -59.45)",
    fill: "#ff3b30"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M699.07,599.56c-1.4,2.17-9.4,5.92-9.4,5.92s.15-8.83,1.55-11a4.68,4.68,0,1,1,7.85,5.09Z",
    transform: "translate(-28.88 -59.45)",
    fill: "#ff3b30"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M698.73,624c-2.31,1.16-11.1.36-11.1.36s4.58-7.55,6.89-8.71a4.68,4.68,0,0,1,4.21,8.36Z",
    transform: "translate(-28.88 -59.45)",
    fill: "#ff3b30"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M694.31,642.47c-2.08,1.54-10.88,2.23-10.88,2.23s3.24-8.22,5.32-9.75a4.68,4.68,0,0,1,5.56,7.52Z",
    transform: "translate(-28.88 -59.45)",
    fill: "#ff3b30"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M679.84,606c1.85,1.8,10.49,3.67,10.49,3.67s-2.11-8.58-4-10.38a4.68,4.68,0,0,0-6.52,6.71Z",
    transform: "translate(-28.88 -59.45)",
    fill: "#ff3b30"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M674.94,627.62c2.31,1.16,11.1.36,11.1.36s-4.58-7.55-6.89-8.71a4.68,4.68,0,0,0-4.21,8.36Z",
    transform: "translate(-28.88 -59.45)",
    fill: "#ff3b30"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M673.06,649.31c2.08,1.54,10.88,2.23,10.88,2.23s-3.24-8.22-5.32-9.75a4.68,4.68,0,0,0-5.56,7.52Z",
    transform: "translate(-28.88 -59.45)",
    fill: "#ff3b30"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M672.33,660.3s11.35-2.27,14.37-5.3,16.64-8.32,18.16-4.54,20.43,16.64,7.56,18.91-30.26,3-34,1.51S672.33,660.3,672.33,660.3Z",
    transform: "translate(-28.88 -59.45)",
    fill: "#a8a8a8"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M712.43,668c-12.86,2.27-30.26,3-34,1.51-2.88-1.15-4.88-6.69-5.67-9.26l-.38.08s2.27,9.08,6.05,10.59,21.18.76,34-1.51c3.71-.66,4.77-2.19,4.37-4.14C716.48,666.51,715.19,667.49,712.43,668Z",
    transform: "translate(-28.88 -59.45)",
    opacity: 0.2
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M860.5,731.46s34.43-6.89,43.62-16.07,50.5-25.25,55.09-13.77,62,50.5,23,57.39-91.82,9.18-103.3,4.59S860.5,731.46,860.5,731.46Z",
    transform: "translate(-28.88 -59.45)",
    fill: "#a8a8a8"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M982.17,754.74c-39,6.89-91.82,9.18-103.3,4.59-8.74-3.5-14.82-20.3-17.22-28.11l-1.15.24s6.89,27.55,18.36,32.14,64.28,2.3,103.3-4.59c11.27-2,14.49-6.66,13.27-12.56C994.48,750.3,990.55,753.27,982.17,754.74Z",
    transform: "translate(-28.88 -59.45)",
    opacity: 0.2
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M1093.54,535.8a21.82,21.82,0,0,1-3.71,11.51,21.82,21.82,0,0,1-3.77-11.49c0-6.35,1.64-11.5,3.71-11.51S1093.52,529.45,1093.54,535.8Z",
    transform: "translate(-28.88 -59.45)",
    fill: "#ff3b30"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M811.25,530.22a21.82,21.82,0,0,1-3.74,11.5,21.82,21.82,0,0,1-3.74-11.5c0-6.35,1.67-11.5,3.74-11.5S811.25,523.87,811.25,530.22Z",
    transform: "translate(-28.88 -59.45)",
    fill: "#ff3b30"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M1118.91,643.54a21.82,21.82,0,0,1,3.74,11.5,21.82,21.82,0,0,1-9.79-7.1c-3.74-5.14-5.41-10.29-3.74-11.5S1115.18,638.41,1118.91,643.54Z",
    transform: "translate(-28.88 -59.45)",
    fill: "#ff3b30"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M999.45,583.33a21.82,21.82,0,0,1-3.74,11.5,21.82,21.82,0,0,1-3.74-11.5c0-6.35,1.67-11.5,3.74-11.5S999.45,577,999.45,583.33Z",
    transform: "translate(-28.88 -59.45)",
    fill: "#ff3b30"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M929.57,545.13a21.82,21.82,0,0,1-3.74,11.5,21.82,21.82,0,0,1-3.74-11.5c0-6.35,1.67-11.5,3.74-11.5S929.57,538.78,929.57,545.13Z",
    transform: "translate(-28.88 -59.45)",
    fill: "#ff3b30"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M886.22,568.42a21.82,21.82,0,0,1,2.47,11.84,21.82,21.82,0,0,1-9-8.12c-3.16-5.51-4.26-10.81-2.47-11.84S883.07,562.91,886.22,568.42Z",
    transform: "translate(-28.88 -59.45)",
    fill: "#ff3b30"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M853.83,674.06a21.82,21.82,0,0,1-10.95,5.14,21.82,21.82,0,0,1,5.83-10.59c4.63-4.34,9.54-6.64,10.95-5.14S858.46,669.72,853.83,674.06Z",
    transform: "translate(-28.88 -59.45)",
    fill: "#ff3b30"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M853.83,674.06a21.82,21.82,0,0,1-10.95,5.14,21.82,21.82,0,0,1,5.83-10.59c4.63-4.34,9.54-6.64,10.95-5.14S858.46,669.72,853.83,674.06Z",
    transform: "translate(-28.88 -59.45)",
    opacity: 0.1
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M921.84,667.54a21.82,21.82,0,0,1-10.95,5.14,21.82,21.82,0,0,1,5.83-10.59c4.63-4.34,9.54-6.64,10.95-5.14S926.47,663.19,921.84,667.54Z",
    transform: "translate(-28.88 -59.45)",
    fill: "#ff3b30"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M921.84,667.54a21.82,21.82,0,0,1-10.95,5.14,21.82,21.82,0,0,1,5.83-10.59c4.63-4.34,9.54-6.64,10.95-5.14S926.47,663.19,921.84,667.54Z",
    transform: "translate(-28.88 -59.45)",
    opacity: 0.1
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M934.88,736.48a21.82,21.82,0,0,1-10.95,5.14A21.82,21.82,0,0,1,929.77,731c4.63-4.34,9.54-6.64,10.95-5.14S939.52,732.13,934.88,736.48Z",
    transform: "translate(-28.88 -59.45)",
    fill: "#ff3b30"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M934.88,736.48a21.82,21.82,0,0,1-10.95,5.14A21.82,21.82,0,0,1,929.77,731c4.63-4.34,9.54-6.64,10.95-5.14S939.52,732.13,934.88,736.48Z",
    transform: "translate(-28.88 -59.45)",
    opacity: 0.1
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M119.35,626.27c15.33,22.63,10.44,103.65,10.44,103.65s-77.05-25.51-92.38-48.13a49.49,49.49,0,0,1,81.95-55.51Z",
    transform: "translate(-28.88 -59.45)",
    fill: "#ff3b30"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M119.35,626.27c15.33,22.63,10.44,103.65,10.44,103.65s-77.05-25.51-92.38-48.13a49.49,49.49,0,0,1,81.95-55.51Z",
    transform: "translate(-28.88 -59.45)",
    opacity: 0.1
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M50.92,613.11S108.66,657.69,130.09,730",
    transform: "translate(-28.88 -59.45)",
    fill: "none",
    stroke: "#535461",
    strokeMiterlimit: 10
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M144.63,668.57s-41-7-13,60.91c0,0,28.49-10.86,30.71-37.88a21.56,21.56,0,0,0-17.15-22.92Z",
    transform: "translate(-28.88 -59.45)",
    fill: "#ff3b30"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M145.23,668.5s7.81,37.56-13.56,61",
    transform: "translate(-28.88 -59.45)",
    fill: "none",
    stroke: "#535461",
    strokeMiterlimit: 10
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M1037.51,731.59s17.11-3.4,21.67-7.93,25.1-12.46,27.38-6.8,30.8,24.92,11.41,28.31-45.63,4.53-51.33,2.27S1037.51,731.59,1037.51,731.59Z",
    transform: "translate(-28.88 -59.45)",
    fill: "#a8a8a8"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M1098,743.08c-19.39,3.4-45.63,4.53-51.33,2.27-4.34-1.73-7.36-10-8.56-13.87l-.57.12s3.42,13.59,9.13,15.86,31.94,1.13,51.33-2.27c5.6-1,7.2-3.28,6.6-6.2C1104.09,740.88,1102.14,742.35,1098,743.08Z",
    transform: "translate(-28.88 -59.45)",
    opacity: 0.2
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 939.95,
    cy: 352.58,
    r: 102.23,
    fill: "#ff3b30"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 831.23,
    cy: 324.65,
    r: 102.23,
    fill: "#ff3b30"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 711.55,
    cy: 325.65,
    r: 102.23,
    fill: "#ff3b30"
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 672.65,
    cy: 352.58,
    r: 102.23,
    fill: "#ff3b30"
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: 606.82,
    cy: 361.56,
    r: 102.23,
    fill: "#ff3b30"
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: 579.89,
    cy: 280.77,
    r: 102.23,
    fill: "#ff3b30"
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    cx: 609.81,
    cy: 187.01,
    r: 102.23,
    fill: "#ff3b30"
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    cx: 666.66,
    cy: 187.01,
    r: 102.23,
    fill: "#ff3b30"
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    cx: 699.58,
    cy: 145.12,
    r: 102.23,
    fill: "#ff3b30"
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    cx: 783.36,
    cy: 191,
    r: 102.23,
    fill: "#ff3b30"
  })), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    cx: 978.85,
    cy: 280.77,
    r: 102.23,
    fill: "#ff3b30"
  })), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    cx: 920,
    cy: 229.9,
    r: 102.23,
    fill: "#ff3b30"
  })), _circle28 || (_circle28 = /*#__PURE__*/React.createElement("circle", {
    cx: 882.1,
    cy: 179.03,
    r: 102.23,
    fill: "#ff3b30"
  })), _circle29 || (_circle29 = /*#__PURE__*/React.createElement("circle", {
    cx: 810.29,
    cy: 102.23,
    r: 102.23,
    fill: "#ff3b30"
  })), _circle30 || (_circle30 = /*#__PURE__*/React.createElement("circle", {
    cx: 943.94,
    cy: 187.01,
    r: 102.23,
    fill: "#ff3b30"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M1070.61,262.47s-95.21-45.15-152.82,34.87",
    transform: "translate(-28.88 -59.45)",
    opacity: 0.1
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M820.53,171s-105.32-3.18-126,93.22",
    transform: "translate(-28.88 -59.45)",
    opacity: 0.1
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M689.61,380.16S594.4,335,536.79,415",
    transform: "translate(-28.88 -59.45)",
    opacity: 0.1
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M272.92,635s5.49,7.18-2.54,18-14.65,20-12,26.76c0,0,12.11-20.14,22-20.42S283.76,647.11,272.92,635Z",
    transform: "translate(-28.88 -59.45)",
    fill: "#ff3b30"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M272.92,635a8.9,8.9,0,0,1,1.12,2.25c9.62,11.3,14.75,21.85,5.5,22.12-8.61.25-18.95,15.65-21.42,19.54a8.35,8.35,0,0,0,.29.89s12.11-20.14,22-20.42S283.76,647.11,272.92,635Z",
    transform: "translate(-28.88 -59.45)",
    opacity: 0.1
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M283.13,644.16c0,2.53-.28,4.58-.63,4.58s-.63-2-.63-4.58.35-1.34.7-1.34S283.13,641.63,283.13,644.16Z",
    transform: "translate(-28.88 -59.45)",
    fill: "#ffd037"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M286.63,647.17c-2.22,1.21-4.16,1.94-4.32,1.63s1.5-1.54,3.72-2.75,1.34-.33,1.51,0S288.85,646,286.63,647.17Z",
    transform: "translate(-28.88 -59.45)",
    fill: "#ffd037"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M243.9,635s-5.49,7.18,2.54,18,14.65,20,12,26.76c0,0-12.11-20.14-22-20.42S233.05,647.11,243.9,635Z",
    transform: "translate(-28.88 -59.45)",
    fill: "#ff3b30"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M243.9,635a8.9,8.9,0,0,0-1.12,2.25c-9.62,11.3-14.75,21.85-5.5,22.12,8.61.25,18.95,15.65,21.42,19.54a8.35,8.35,0,0,1-.29.89s-12.11-20.14-22-20.42S233.05,647.11,243.9,635Z",
    transform: "translate(-28.88 -59.45)",
    opacity: 0.1
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M233.69,644.16c0,2.53.28,4.58.63,4.58s.63-2,.63-4.58-.35-1.34-.7-1.34S233.69,641.63,233.69,644.16Z",
    transform: "translate(-28.88 -59.45)",
    fill: "#ffd037"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M230.18,647.17c2.22,1.21,4.16,1.94,4.32,1.63s-1.5-1.54-3.72-2.75-1.34-.33-1.51,0S228,646,230.18,647.17Z",
    transform: "translate(-28.88 -59.45)",
    fill: "#ffd037"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M235.44,678.85s15.36-.47,20-3.77,23.63-7.23,24.77-1.95,23.08,26.29,5.74,26.43-40.29-2.7-44.91-5.52S235.44,678.85,235.44,678.85Z",
    transform: "translate(-28.88 -59.45)",
    fill: "#a8a8a8"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M286.25,697.73c-17.34.14-40.29-2.7-44.91-5.52-3.52-2.14-4.92-9.83-5.39-13.38l-.51,0s1,12.39,5.59,15.2,27.57,5.66,44.91,5.52c5,0,6.73-1.82,6.64-4.46C291.89,696.7,290,697.7,286.25,697.73Z",
    transform: "translate(-28.88 -59.45)",
    opacity: 0.2
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M148.44,777.74a11.67,11.67,0,0,0,3.83-5.78c.5-2.3-.48-5.05-2.68-5.89-2.46-.94-5.09.76-7.08,2.49s-4.28,3.69-6.89,3.32a10.48,10.48,0,0,0,3.24-9.81,4.1,4.1,0,0,0-.9-2c-1.37-1.46-3.84-.83-5.48.32-5.2,3.66-6.65,10.72-6.68,17.08-.52-2.29-.08-4.68-.1-7s-.66-5-2.64-6.22a8,8,0,0,0-4-.95c-2.34-.09-4.94.15-6.54,1.86-2,2.12-1.47,5.69.26,8s4.35,3.8,6.77,5.42a15,15,0,0,1,4.84,4.61,4.57,4.57,0,0,1,.36.82h14.65A40.83,40.83,0,0,0,148.44,777.74Z",
    transform: "translate(-28.88 -59.45)",
    fill: "#ff3b30"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M1058.44,791.74a11.67,11.67,0,0,0,3.83-5.78c.5-2.3-.48-5.05-2.68-5.89-2.46-.94-5.09.76-7.08,2.49s-4.28,3.69-6.89,3.32a10.48,10.48,0,0,0,3.24-9.81,4.1,4.1,0,0,0-.9-2c-1.37-1.46-3.84-.83-5.48.32-5.2,3.66-6.65,10.72-6.68,17.08-.52-2.29-.08-4.68-.1-7s-.66-5-2.64-6.22a8,8,0,0,0-4-.95c-2.34-.09-4.94.15-6.54,1.86-2,2.12-1.47,5.69.26,8s4.35,3.8,6.77,5.42a15,15,0,0,1,4.84,4.61,4.57,4.57,0,0,1,.36.82h14.65A40.83,40.83,0,0,0,1058.44,791.74Z",
    transform: "translate(-28.88 -59.45)",
    fill: "#ff3b30"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M717.57,786.32s-1,15.66,1,18.26c0,0-45.92,8.35-51.66,5.74s-3.13-6.78,0-8.35,18.79-7.31,20.87-18.26c0,0-6.78-3.13,15.13,1S717.57,786.32,717.57,786.32Z",
    transform: "translate(-28.88 -59.45)",
    fill: "#dc9ba3"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M717.57,786.32s-1,15.66,1,18.26c0,0-45.92,8.35-51.66,5.74s-3.13-6.78,0-8.35,18.79-7.31,20.87-18.26c0,0-6.78-3.13,15.13,1S717.57,786.32,717.57,786.32Z",
    transform: "translate(-28.88 -59.45)",
    opacity: 0.05
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M896.56,634.46s-5.74,9.39-2.09,27.66-9.39,18.26-9.39,18.26H859l-8.87-23,12.52,1s8.35-2.09,4.7-21.4Z",
    transform: "translate(-28.88 -59.45)",
    fill: "#ffd2d9"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M818.29,612.55c4,12.71,9,28.19,11.67,36.44l1.9,5.83,17.22-17.74s-.76-1.76-1.89-4.22c-2.52-5.46-6.91-14.37-9.07-15.09,0,0,24-1.57,31.31,4.17s5.22-15.66,5.22-15.66-14.09-1-19.31-4.17-33.4-6.26-33.4-6.26S812.55,594.28,818.29,612.55Z",
    transform: "translate(-28.88 -59.45)",
    fill: "#ffd2d9"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M661.73,766l3.65,26.61,9.39-1s.57-.54,1.53-1.4c2.53-2.23,7.8-6.6,12.84-9a15.73,15.73,0,0,1,5.46-1.63l-10.44-15.66a57.66,57.66,0,0,1-7.79,2.31,37.61,37.61,0,0,1-8.39,1A15.32,15.32,0,0,1,661.73,766Z",
    transform: "translate(-28.88 -59.45)",
    fill: "#ffd2d9"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M687.82,784.76c4.7,4.17,26.09-4.7,29.75,8.87l3.36-12.87,10.35-39.6,1.42-5.45,8.62-.37,98.93-4.22,5.6-.24,3-.13-3.92-1.94-26.09-12.93s-9.4-.66-22.36-2.44h0c-19.65-2.69-47.49-8-63.21-17.39-26.09-15.66-36,37.05-36,37.05s-4,13.37-7,26.55a153.76,153.76,0,0,0-3.15,17.25C686.67,780.93,686.81,783.85,687.82,784.76Z",
    transform: "translate(-28.88 -59.45)",
    fill: "#e9e9ef"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M687.82,784.76c4.7,4.17,26.09-4.7,29.75,8.87l3.36-12.87,10.35-39.6,1.42-5.45,8.89-.55,95.58-5.88,5.9-.37,1.82-.11,2.35-.15-28.44-12.79s-9.4-.66-22.36-2.44h0c-19.65-2.69-47.49-8-63.21-17.39-26.09-15.66-36,37.05-36,37.05s-4,13.37-7,26.55a153.76,153.76,0,0,0-3.15,17.25C686.67,780.93,686.81,783.85,687.82,784.76Z",
    transform: "translate(-28.88 -59.45)",
    opacity: 0.05
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M676.38,766.19l9.13,10.71,3.64,4.27a15.73,15.73,0,0,1,5.46-1.63l-10.44-15.66A57.66,57.66,0,0,1,676.38,766.19Z",
    transform: "translate(-28.88 -59.45)",
    opacity: 0.1
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M676.87,764.93l10.21,12,4.92,5.77v1.57c6,1.39,24.79-2.57,28.93-3.48l.81-.18c12,.52,56.36-25.57,56.36-25.57s48.53,8.35,72,6.26c13.11-1.17,16.79-5.91,17.48-9.88a10.29,10.29,0,0,0-.78-5.78l-21-14.75-2.78-2-4.44-3.13s-7.72-1.75-17.52-3.91h0c-15.32-3.38-35.73-7.77-39.86-8.08-6.78-.52-24,5.22-33.92,16.7a29.31,29.31,0,0,1-5.72,4.67l-.27.18c-2.79,1.85-6.22,3.81-10,5.82-12.63,6.65-29.47,13.8-41.05,18.49C682.32,762.86,676.87,764.93,676.87,764.93Z",
    transform: "translate(-28.88 -59.45)",
    fill: "#e9e9ef"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M661.73,766l3.65,26.61,9.39-1s.57-.54,1.53-1.4c-2.08,0-5.51-.55-6.23-4.86,0,0,3.62-12.65-2.09-18.1A15.32,15.32,0,0,1,661.73,766Z",
    transform: "translate(-28.88 -59.45)",
    opacity: 0.1
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M669,785.28s5.22-18.26-6.78-20.35l-19.83,7.83-23,1.57s-6,9.79,3.61,20.77A29.52,29.52,0,0,0,643.94,805L669,806.15,676.87,790S670.08,791.54,669,785.28Z",
    transform: "translate(-28.88 -59.45)",
    fill: "#dc9ba3"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M796.45,713.44c2.63.77,13.51,4,24.65,8.43h0a137.31,137.31,0,0,1,16.06,7.41c1.08.61,2.11,1.22,3.08,1.83a26.56,26.56,0,0,1,6.73,5.64c6.44,8.33,15.9,12.82,20.61,14.65a10.29,10.29,0,0,0-.78-5.78l-21-14.75,3-.13-3.92-1.94,2.35-.15-28.44-12.79S809.41,715.22,796.45,713.44Z",
    transform: "translate(-28.88 -59.45)",
    opacity: 0.1
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M830,649l1.9,5.83,17.22-17.74s-.76-1.76-1.89-4.22C845,637.46,834.61,645.52,830,649Z",
    transform: "translate(-28.88 -59.45)",
    opacity: 0.1
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M892.09,657.65a30.34,30.34,0,0,0,1.35-5.44L915.87,660s15.39,11.74,13.83,37.31c0,0-19-7-27.4,1.3l-.17,1.47a67.84,67.84,0,0,1-18.4,38.82c-4.15,4.36-8.06,9.27-10.13,14,0,0-14.61-4.17-23.48-15.66S799,713.79,799,713.79s22.44.52,25.57-7.31,13.57-24.53,9.92-37.57-5.74-17.22-5.74-17.22,21.4-15.13,19.83-19.83l13.57,15.66,6.26,2.09a10,10,0,0,0-.74,3.82C867.31,667.6,887.33,671,892.09,657.65Z",
    transform: "translate(-28.88 -59.45)",
    fill: "#cedad5"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M868.13,643.93a54.1,54.1,0,0,0-.79-5.81l29.22-2.61s-2,1.75-2.9,8.27c-3.43,2-7.43,4.78-11.71,4.78A22.86,22.86,0,0,1,868.13,643.93Z",
    transform: "translate(-28.88 -59.45)",
    opacity: 0.1
  })), _circle31 || (_circle31 = /*#__PURE__*/React.createElement("circle", {
    cx: 852.81,
    cy: 565.36,
    r: 22.96,
    fill: "#ffd2d9"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M898.65,630.81h-3.13v-8.87l-3.13-9.39s-15.66-7.31-23-5.74L863.69,612s-1.57-12.52,7.83-17.22,26.09-2.61,30.27,1,11,9.92,5.74,27.14L906,627.16S899.69,625.07,898.65,630.81Z",
    transform: "translate(-28.88 -59.45)",
    fill: "#844f6e"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.05
  }, /*#__PURE__*/React.createElement("path", {
    d: "M858.09,642.86l-1.71-.57-7.88-9.09a2.22,2.22,0,0,0,.05-1.34Z",
    transform: "translate(-28.88 -59.45)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M869.07,659.7a11.82,11.82,0,0,1-7.17-11.5c0-.31,0-.6,0-.88l.16.19,6.26,2.09a10,10,0,0,0-.74,3.82A12.47,12.47,0,0,0,869.07,659.7Z",
    transform: "translate(-28.88 -59.45)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M808.2,713.36c13.08,4.55,30.79,11.72,36.18,18.69l.4.5c-14.33-9.83-45.8-18.77-45.8-18.77A81.34,81.34,0,0,0,808.2,713.36Z",
    transform: "translate(-28.88 -59.45)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M867.86,747.71c2.07-4.71,6-9.63,10.13-14a67.84,67.84,0,0,0,18.4-38.82l.17-1.47c8.35-8.35,27.4-1.3,27.4-1.3,1-16.22-4.84-26.87-9.23-32.49l1.15.4s15.39,11.74,13.83,37.31c0,0-19-7-27.4,1.3l-.17,1.47a67.84,67.84,0,0,1-18.4,38.82c-4.15,4.36-8.06,9.27-10.13,14,0,0-12.72-3.64-21.62-13.44A54,54,0,0,0,867.86,747.71Z",
    transform: "translate(-28.88 -59.45)"
  }))), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M873.6,686.65s25,36,38.09,46.44,16.7-4.7,16.7-4.7V695l-23-2.61-.25,3.17-.28,3.62-21.4-23s-21.4-19.31-25.57-7.83S873.6,686.65,873.6,686.65Z",
    transform: "translate(-28.88 -59.45)",
    fill: "#ffd2d9"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M905.19,695.56a49.72,49.72,0,0,0,9.9,4.4c4.93,1.52,10.58-.08,13.31-1.06V695l-23-2.61Z",
    transform: "translate(-28.88 -59.45)",
    opacity: 0.1
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M928.66,691.61,930,697.2s-8.16,3.8-14.94,1.72a59.33,59.33,0,0,1-13-6.26c-1-.52,4.17-6.26,4.17-6.26Z",
    transform: "translate(-28.88 -59.45)",
    fill: "#cedad5"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M778.36,755.27A42.39,42.39,0,0,0,766.88,749a41,41,0,0,1-11-5.74",
    transform: "translate(-28.88 -59.45)",
    opacity: 0.1
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M619.46,774.32l.85-.06c-1.24,3.15-3,10.85,4.32,19.26a29.52,29.52,0,0,0,20.87,9.89l24.3,1.14-.78,1.6L643.94,805a29.52,29.52,0,0,1-20.87-9.89C613.46,784.11,619.46,774.32,619.46,774.32Z",
    transform: "translate(-28.88 -59.45)",
    fill: "#fff",
    opacity: 0.2
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M708.07,796.69q-.11.47-.25.93C707.31,797.33,706.58,796.77,708.07,796.69Z",
    transform: "translate(-28.88 -59.45)",
    fill: "lime",
    opacity: 0.05
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M667,808.76c5.35,2.43,45.57-4.65,51-5.63a4.06,4.06,0,0,0,.62,1.45s-45.92,8.35-51.66,5.74c-3-1.34-3.69-3.1-3.29-4.7C664,806.74,664.94,807.85,667,808.76Z",
    transform: "translate(-28.88 -59.45)",
    fill: "#fff",
    opacity: 0.2
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M867.1,613.84a35.56,35.56,0,0,1-13.24-14.2,3.2,3.2,0,0,1-.49-2.19c.37-1.42,2.22-1.67,3.56-2.28,2.49-1.14,3.54-4,5.17-6.22a12.45,12.45,0,0,1,12.17-4.67c2.38.48,4.58,1.66,7,2,5.18.76,10.82-2.38,15.47,0,2.12,1.09,3.56,3.14,4.82,5.16,3.17,5.07,7.14,10.46,4.26,16.38-1.65,3.4-4.29,6.22-8,7.21s-8,.16-11.78-.24c-3.1-.34-6.36-1-9.48-.72C872.88,614.45,870.59,615.94,867.1,613.84Z",
    transform: "translate(-28.88 -59.45)",
    opacity: 0.1
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M867.1,612.79a35.56,35.56,0,0,1-13.24-14.2,3.2,3.2,0,0,1-.49-2.19c.37-1.42,2.22-1.67,3.56-2.28,2.49-1.14,3.54-4,5.17-6.22a12.45,12.45,0,0,1,12.17-4.67c2.38.48,4.58,1.66,7,2,5.18.76,10.82-2.38,15.47,0,2.12,1.09,3.56,3.14,4.82,5.16,3.17,5.07,7.14,10.46,4.26,16.38-1.65,3.4-4.29,6.22-8,7.21s-8,.16-11.78-.24c-3.1-.34-6.36-1-9.48-.72C872.88,613.4,870.59,614.9,867.1,612.79Z",
    transform: "translate(-28.88 -59.45)",
    fill: "#844f6e"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M436.94,737.11c0,10.76.6,17.87.6,17.87s15.37.86,14.94,15.11,59.74,17.27,59.74,17.27,0-.15,0-.43h0s0-1.15,0-3.23c5.72.85,11.84,1.54,15.27,1.21-.23,1.11-.5,2.28-.76,3.32-.28.28-5.82,5.88-5.64,11.84-.1,3,1.26,6.08,5.66,8.64C539.45,816.13,579,812,579,812c6-3.94,8-7.29,7.89-10.07.19-4.1-3.9-7-7.65-8.87a13.5,13.5,0,0,0-9.36-1,44.92,44.92,0,0,1-12.91.95,20,20,0,0,1,.67-2.54c4.06,1.15,6.86,2,6.86,2s21.08-11.22,12.3-29.35a14.85,14.85,0,0,0-6-5.93c6.77-11.67,13.2-25.41,12.56-34.65-1.07-15.42-31.69-12.06-43.16-10.25L518.09,690.6c0-16,.49-34.37-1-38.35-2.64-6.91-1.76-6-3.51-9.06l-.07-.11c-1-1.62-3.72-4.19-4.42-3.84a44.62,44.62,0,0,1,.13-9.55A27.25,27.25,0,0,0,528,603.91a26.68,26.68,0,0,0-3-12.31l.3-.13-2.9-14.26a2.37,2.37,0,0,1,.13-1.85c.3-.4.81-.52,1.2-.8a2.76,2.76,0,0,0,.47-3.36,4.58,4.58,0,0,0-1.09-1.39c-2.44-2.77-7.63-1.78-10.82-2.19-4.32-.55-8.85-1.35-12.94.79a21.38,21.38,0,0,1-2.75,1.44,11.84,11.84,0,0,1-4,.38,40.4,40.4,0,0,0-7.26.65c-3.12-1.13-6.79-.13-9.68,1.6A21.35,21.35,0,0,0,465.5,592a41.36,41.36,0,0,0,1.39,7.15L472.24,620a13.59,13.59,0,0,0,2,4.88,5.75,5.75,0,0,0,.8.86,4.63,4.63,0,0,0,4.26,1.62,2.89,2.89,0,0,0,.59-.21,29.57,29.57,0,0,1-1.27,6.46c-6.12,1.78-15,8-25.66,26C439.28,682.67,437,716.67,436.94,737.11Zm87.3-14.64h0Z",
    transform: "translate(-28.88 -59.45)",
    fill: "url(#d91c7811-87ec-4fc8-aa52-46c2543d8327-428)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 490.14,
    y: 724.24,
    width: 59.84,
    height: 42.86,
    transform: "translate(1011.23 1431.89) rotate(-180)",
    fill: "#5f5d7e"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M535.12,714.9s44.56-9.34,45.83,9.34-26.31,56-26.31,56l-25-5.09,7.21-28.86s-28.43-6.37-30.13-6.79S535.12,714.9,535.12,714.9Z",
    transform: "translate(-28.88 -59.45)",
    fill: "#5f5d7e"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M535.12,714.9s44.56-9.34,45.83,9.34-26.31,56-26.31,56l-25-5.09,7.21-28.86s-28.43-6.37-30.13-6.79S535.12,714.9,535.12,714.9Z",
    transform: "translate(-28.88 -59.45)",
    opacity: 0.1
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M558.47,785.35s-4.24,8.06-3,11.46-30.13-4.67-30.13-4.67,2.55-9.76,2.12-11S558.47,785.35,558.47,785.35Z",
    transform: "translate(-28.88 -59.45)",
    fill: "#5f5d7e"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M530.88,730.18,534,733l2,1.82s10.19,16.55,23.34,6.37S549.13,723.39,544.46,723a5.86,5.86,0,0,1-4.4-3.19,14,14,0,0,1-1.54-4Z",
    transform: "translate(-28.88 -59.45)",
    fill: "#fdc2cc"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M530.88,730.18,534,733l2,1.82s10.19,16.55,23.34,6.37S549.13,723.39,544.46,723a5.86,5.86,0,0,1-4.4-3.19,14,14,0,0,1-1.54-4Z",
    transform: "translate(-28.88 -59.45)",
    opacity: 0.05
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M558.47,785.35s-4.24,8.06-3,11.46-30.13-4.67-30.13-4.67,2.55-9.76,2.12-11S558.47,785.35,558.47,785.35Z",
    transform: "translate(-28.88 -59.45)",
    opacity: 0.1
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M530.88,730.18,534,733c0-5.44,3.61-10.44,6.08-13.25a14,14,0,0,1-1.54-4Z",
    transform: "translate(-28.88 -59.45)",
    opacity: 0.1
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M512.21,687.32l29.28,29.28s-10.19,8.91-8.06,18.25l-21.22-23.77Z",
    transform: "translate(-28.88 -59.45)",
    fill: "#c4c8e2"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M512.42,687.32v23.77l3.4,3.81,10.09,11.3,7.73,8.66c-2.12-9.34,8.06-18.25,8.06-18.25Z",
    transform: "translate(-28.88 -59.45)",
    opacity: 0.1
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M512.21,645.3s0,8.91-7.64,6.37-1.7,100.58-1.7,100.58,22.07-16.55,17.82-28.43S515.6,703,516,691.14,512.21,645.3,512.21,645.3Z",
    transform: "translate(-28.88 -59.45)",
    fill: "#d39999"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M511.78,621.54s-6.37,17.4,0,30.56S474,644.88,474,644.88s9.76-4.67,6.37-27.16Z",
    transform: "translate(-28.88 -59.45)",
    fill: "#fdc2cc"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M515.6,700.9a125.19,125.19,0,0,0,0,14l10.09,11.3a85.06,85.06,0,0,0-5-9.17c-1.57-2.43-1.92-12.12-2-23.18l-3.7-3.7C515.38,696.12,515.6,700.9,515.6,700.9Z",
    transform: "translate(-28.88 -59.45)",
    opacity: 0.1
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M509,643c-.47-2.23,3.21,1.13,4.39,3.08l.06.11c1.7,3,.85,2.12,3.4,8.91s-.85,56,3,62a95.5,95.5,0,0,1,6.79,13.16l-6.79-2.55s-2.55-7.64-4.24-9.34-.85-17.4-.85-17.4-1.27-27.16-2.55-33.1C511.2,663.09,510,647.69,509,643Z",
    transform: "translate(-28.88 -59.45)",
    fill: "#c4c8e2"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M509,643c-.47-2.23,3.21,1.13,4.39,3.08l.06.11c1.7,3,.85,2.12,3.4,8.91s-.85,56,3,62a95.5,95.5,0,0,1,6.79,13.16l-6.79-2.55s-2.55-7.64-4.24-9.34-.85-17.4-.85-17.4-1.27-27.16-2.55-33.1C511.2,663.09,510,647.69,509,643Z",
    transform: "translate(-28.88 -59.45)",
    opacity: 0.1
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M499.05,748.85s67.05-2.55,75.54,15.28S562.71,793,562.71,793s-28.43-8.91-34.8-7.64-28.86-3.4-28.86-3.4Z",
    transform: "translate(-28.88 -59.45)",
    fill: "#5f5d7e"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M536.4,737.82s15.28-8.49,23.77-3,7.64,20.37-4.24,20.79-18.25-6.79-18.25-6.79Z",
    transform: "translate(-28.88 -59.45)",
    fill: "#fdc2cc"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M488.44,637.24s-13.58-9.34-33.53,25-14.85,93.36-14.85,93.36,14.85.85,14.43,14.85,57.72,17,57.72,17-.85-139.2-6.79-143S488.44,637.24,488.44,637.24Z",
    transform: "translate(-28.88 -59.45)",
    fill: "#c4c8e2"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M488.38,662.56a18.59,18.59,0,0,1,7.72,15.12c.07,12.71.38,40.1,1.67,45.28,1.7,6.79,27.16,15.7,40.32,15.28,0,0,6.37,11.88-1.27,14.43s-54.32,0-54.32,0-18.25-20.79-18.67-39-3-38.62,0-42.44C466.28,668,476.53,654.2,488.38,662.56Z",
    transform: "translate(-28.88 -59.45)",
    opacity: 0.1
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M489.23,660.86A18.59,18.59,0,0,1,497,676c.07,12.71.38,40.1,1.67,45.28,1.7,6.79,27.16,15.7,40.32,15.28,0,0,6.37,11.88-1.27,14.43s-54.32,0-54.32,0-18.25-20.79-18.67-39-3-38.62,0-42.44C467.13,666.34,477.38,652.5,489.23,660.86Z",
    transform: "translate(-28.88 -59.45)",
    fill: "#c4c8e2"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M576.95,793.51c6.09,3,13.15,9.18-.23,18.57,0,0-38.19,4.24-50.5-3.4s0-19.95,0-19.95,28.17,7.49,41.69,3.83A12.83,12.83,0,0,1,576.95,793.51Z",
    transform: "translate(-28.88 -59.45)",
    fill: "#4c4c56"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M576.95,794.37c6.09,2.9,13.15,8.78-.23,17.77,0,0-38.19,4.06-50.5-3.25s0-19.08,0-19.08,28.17,7.16,41.69,3.67A13.36,13.36,0,0,1,576.95,794.37Z",
    transform: "translate(-28.88 -59.45)",
    opacity: 0.1
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M490.35,692.62s2.12,26.74,16.13,32.68",
    transform: "translate(-28.88 -59.45)",
    opacity: 0.1
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M511.36,624.51a54.46,54.46,0,0,0-2.51,11.34c-2.68.9-6.6-1.36-9.59-1.36-7.78,0-10-8.7-14.85-14,0-2.36-4,3.15-4.46.21Z",
    transform: "translate(-28.88 -59.45)",
    opacity: 0.1
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M474,607.53a26.86,26.86,0,0,0,.81,6.58l.09.34a26.87,26.87,0,1,0-.9-6.91Z",
    transform: "translate(-28.88 -59.45)",
    fill: "#fdc2cc"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M454.92,662.7a101,101,0,0,1,9.49-13.88,108,108,0,0,0-7.79,11.76c-19.95,34.38-14.85,93.36-14.85,93.36s14.85.85,14.43,14.85c-.38,12.57,46.41,16.25,56,16.87,0,1.44,0,2.22,0,2.22s-58.14-3-57.72-17-14.43-14.85-14.43-14.85S435,697.08,454.92,662.7Z",
    transform: "translate(-28.88 -59.45)",
    opacity: 0.1
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M477.39,577c2.8-1.69,6.34-2.68,9.36-1.57a38.38,38.38,0,0,1,7-.64,11.25,11.25,0,0,0,3.82-.37,20.53,20.53,0,0,0,2.66-1.41c3.95-2.1,8.33-1.31,12.5-.77,3.39.44,9.12-.79,11.08,3.09a2.75,2.75,0,0,1-.45,3.3c-.38.28-.87.39-1.16.79a2.37,2.37,0,0,0-.13,1.82l2.8,14a10.52,10.52,0,0,1-8.33.38,23.44,23.44,0,0,1-2.2-1c-2.09,1.36-4.25.33-6.78.87a7.73,7.73,0,0,0-3.82,2.5,22.24,22.24,0,0,0-5.67,11.29c-.28,1.59-.65,3.55-2.19,4a10.05,10.05,0,0,1-1.77.18c-2.78.36-3.92,3.65-5.71,5.82-2.18,2.64-6.09,4.36-6.33,7.78-.06.88.13,1.85-.36,2.59a2.18,2.18,0,0,1-1.36.84,4.59,4.59,0,0,1-4.46-2,13.49,13.49,0,0,1-1.89-4.79l-5.17-20.5a41.31,41.31,0,0,1-1.35-7A21.1,21.1,0,0,1,477.39,577Z",
    transform: "translate(-28.88 -59.45)",
    opacity: 0.1
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M477,576.62c2.8-1.69,6.34-2.68,9.36-1.57a38.38,38.38,0,0,1,7-.64,11.25,11.25,0,0,0,3.82-.37,20.53,20.53,0,0,0,2.66-1.41c3.95-2.1,8.33-1.31,12.5-.77,3.39.44,9.12-.79,11.08,3.09a2.75,2.75,0,0,1-.45,3.3c-.38.28-.87.39-1.16.79a2.37,2.37,0,0,0-.13,1.82l2.8,14a10.52,10.52,0,0,1-8.33.38,23.44,23.44,0,0,1-2.2-1c-2.09,1.36-4.25.33-6.78.87a7.73,7.73,0,0,0-3.82,2.5,22.24,22.24,0,0,0-5.67,11.29c-.28,1.59-.65,3.55-2.19,4a10.05,10.05,0,0,1-1.77.18c-2.78.36-3.92,3.65-5.71,5.82-2.18,2.64-6.09,4.36-6.33,7.78-.06.88.13,1.85-.36,2.59a2.18,2.18,0,0,1-1.36.84,4.59,4.59,0,0,1-4.46-2,13.49,13.49,0,0,1-1.89-4.79l-5.17-20.5a41.31,41.31,0,0,1-1.35-7A21.1,21.1,0,0,1,477,576.62Z",
    transform: "translate(-28.88 -59.45)",
    fill: "#865a61"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnectopiaLandingPage);
export default __webpack_public_path__ + "static/media/ConnectopiaLandingPage.1ce3531d4aaae480107bf07bad4bc55c.svg";
export { ForwardRef as ReactComponent };